export default __webpack_public_path__ + "static/media/noproviderImage.b17d0959.svg";